// extracted by mini-css-extract-plugin
module.exports = {"titleCnt":"style_titleCnt__aHQW0","downloader":"style_downloader__2fl0o"};